// extracted by mini-css-extract-plugin
module.exports = {"badges":"styles_badges__6_D7j","badge":"styles_badge__gK_fV","deliveryIcon":"styles_deliveryIcon__yu8eE"};